import React, { Component } from "react";
import { IoIosCloseCircleOutline } from "react-icons/io";
import TeamApis from "../../helper/teams.api";
import { errorHandler } from "../../utils/common.utils";
import Image from "../common/Image";

export default class FFAParticipantDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showTeamDetails: true,
      participants: [],
      selectedPlayer: {},
    };
    this.teamApis = new TeamApis();
  }
  componentDidMount() {
    this.setState({ participants: this.props.details, showTeamDetails: false });
  }
  getData = () => {
    const data = {
      _id: this.props.details._id,
    };
    this.props.updateLoader(true);
    this.teamApis
      .getTeams(data)
      .then(res => {
        this.setState({ participants: res.data.result[0].members.players });
        this.props.updateLoader(false);
      })
      .catch(err => {
        this.props.updateLoader(false);
        errorHandler(err);
      });
  };
  render() {
    return (
      <div className="p-3">
        <IoIosCloseCircleOutline
          className="close-icon position-absolute"
          style={{ right: "15px" }}
          onClick={() => this.props.onClose()}
        />
        <div className="row mt-3">
          <h1 className="fs-20 fw-600 text-white text-center mb-3">Participants</h1>
          {this.state.participants.map((el, i) => {
            if (el !== null) {
              return (
                <div className="col-lg-12 col-md-12 col-12 d-block" key={i}>
                  <div className="row mulberry-purple-card align-items-center py-2 mb-2 mx-1">
                    <div className="col-3">
                      <Image
                        src={this.props.type === "TEAM" ? el?.logo?.url : el?.profilePicture?.url}
                        param={this.props.type === "TEAM" ? el?.name : el?.inGameName}
                        className="rounded-circle mx-2 btn-size-32"
                      />
                    </div>
                    <div className="col-7">
                      <p className="fs-16 fw-bold text-white my-1 text-truncate">
                        {this.props.type === "TEAM" ? el?.name : el?.inGameName}
                      </p>
                    </div>
                  </div>
                </div>
              );
            }
          })}
        </div>
      </div>
    );
  }
}
